import { render, staticRenderFns } from "./CamaraVOD.vue?vue&type=template&id=b27fc4a6&"
import script from "./CamaraVOD.vue?vue&type=script&lang=ts&"
export * from "./CamaraVOD.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraVOD.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports